import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";
import { HubTableTemplate } from "../../components";

export const StyledSubStack = styled(Stack)(({ theme }) => ({
  padding: "12px 16px",
  backgroundColor: theme.palette.hubColors.greyLightest,
}));

export const StyledStack = styled(Stack)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "start",
  gap: "0px",
  borderRadius: "6px",
  padding: "12px 16px",
  backgroundColor: theme.palette.hubColors.white,
  overflow: "hidden",
}));

export const StyledLineItemsLabel = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: "6px",
  padding: "8px 14px",
  borderBottom: `1px solid ${theme.palette.hubColors.greyLight}`,
  backgroundColor: theme.palette.hubColors.greyLighter,
  width: "100%",
}));

export const StyledHubTableTemplate = styled(HubTableTemplate)({
});

export const StyledChevronCell = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  alignItems: "center",
  justifyContent: "center",
  width: "24px",
  height: "24px",
  borderRadius: "6px",
  cursor: "pointer",
  transition: "background-color 0.15s ease, transform 0.2s ease",
  transform: open ? "rotate(90deg)" : "rotate(0deg)",
  "&:hover": {
    backgroundColor: theme.palette.hubColors.mainFocusLightest,
    color: theme.palette.hubColors.mainFocus,
  },
}));
